import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const TestimonialsSection = () => {
  return (
    <section className="relative bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-6 tracking-tight">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it—hear from businesses we've helped succeed.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-gray-50 border border-gray-200 p-8 hover:border-[#0099FF]/50 hover:shadow-lg transition-all duration-400 group"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote className="text-[#0099FF]/30 group-hover:text-[#0099FF]/50 transition-colors duration-400" size={40} />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-[#0099FF] fill-[#0099FF]" size={16} />
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-6 text-base">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="pt-6 border-t border-gray-200">
                <div className="font-semibold text-gray-900 mb-1">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-600">
                  {testimonial.role}
                </div>
                <div className="text-sm text-[#0099FF] mt-1">
                  {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
